export default __webpack_public_path__ + "static/media/eth-greet.9d779bd1.svg";